import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { Router } from '@angular/router';

import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideLogIn } from '@ng-icons/lucide';

import { ZardButtonComponent } from '@/shared/components/button';
import { ZardCardComponent } from '@/shared/components/card';
import { AuthService } from '@core/auth/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    NgIcon,
    ZardCardComponent,
    ZardButtonComponent,
  ],
  viewProviders: [provideIcons({ lucideLogIn })],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex min-h-screen items-center justify-center bg-muted">
      <z-card class="w-full max-w-sm">
        <div class="flex flex-col gap-6 p-6">
          <div class="text-center">
            <h1 class="text-2xl font-semibold">My enshift — Admin</h1>
            <p class="text-sm text-muted-foreground mt-1">
              Sign in to manage customers and view audit events
            </p>
          </div>

          <button
            z-button
            zType="default"
            [zFull]="true"
            [zLoading]="redirecting()"
            [zDisabled]="redirecting()"
            type="button"
            (click)="onSignIn()"
          >
            @if (redirecting()) {
              Redirecting…
            } @else {
              <ng-icon name="lucideLogIn" class="size-4" />
              Sign in with ZITADEL
            }
          </button>
        </div>
      </z-card>
    </div>
  `,
})
export class LoginComponent implements OnInit {
  protected readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  protected readonly redirecting = signal(false);

  async ngOnInit(): Promise<void> {
    // adminPublicGuard handles the fast path, but await bootstrap here as a
    // belt-and-suspenders check in case the guard was bypassed.
    await this.authService.ensureAuthReady();
    if (this.authService.isAuthenticated() && this.authService.currentUser()?.role === 'admin') {
      void this.router.navigate(['/customers']);
    }
  }

  protected onSignIn(): void {
    this.redirecting.set(true);
    this.authService.login();
  }
}
